import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTooth } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

// components

import { Cards } from 'app-components';
import GIButton from '@components/common/button/GIButton';
// utilities

import { configs } from '@constants/configs/configs';

// types

import type { Partner } from './useGaep';

// props

interface GAEPListProps {
    data: {
        payload: {
            partners: Partner[];
        }
    };
    isInsCompanyMode: boolean;
    zipcode?: string | null;
    onHandleClickExternalUrl: (url: string | null) => void;
    onClickCheckAvailability?: () => void;
    onChangeZipcode?: () => void;
    onHandleShowAll?: () => void;
}

// styles

const StyledLink = styled.div`
    color: '#104556';
    font-size: 1.8rem;
    float: right;
`;


const GAEPList = (props: GAEPListProps) => {

    const { data, isInsCompanyMode, zipcode, onChangeZipcode, onClickCheckAvailability, onHandleClickExternalUrl, onHandleShowAll } = props;
    const navigate = useNavigate();

    const {
        routes: {
            ANON_GA_CARRIERS,
            ANON_GA_GAEPS
        }
    } = configs;

    const InsCompanyHeader = () => {
        return (
            <>
                <div className={'desktop:grid-col-12 tablet:grid-col-12 mobile:grid-col-12 select-list_results_col'}>
                    <div className={'grid-row select-list_results_col_row'}>
                        <div className='desktop:grid-col-auto tablet:grid-col-auto mobile:grid-col-12 heading'>
                            <h2><FormattedMessage id="gaep.ins_company.select_from_ins_companies" values={{ count: data?.payload?.partners.length | 0 }}/></h2>
                        </div>
                        <div className={'desktop:grid-col tablet:grid-col mobile:grid-col-12 heading_link'}>
                            {
                                zipcode &&
                                <>
                                    <div className={'heading_link_zipcode'}><span className={'h2'}> <FormattedMessage id='gaep.in_zip' values={{ zipcode }} /></span>{' '}
                                        <a href="#" onClick={onChangeZipcode}><FormattedMessage id='gaep.change' /></a>{' '}
                                        <a href="#" onClick={onHandleShowAll}><FormattedMessage id='carriers.show_all_ins_companies' /></a>
                                    </div>
                                </>
                            }
                            {
                                !zipcode &&
                                <div className={'heading_link_ava'}><a href="#" onClick={onClickCheckAvailability}><FormattedMessage id="gaep.ins_company.check_avail"/></a> <FormattedMessage id="gaep.ins_company.check_avail.continue"/></div>
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const onHandleCarrierLink = () => {
        navigate(ANON_GA_CARRIERS);
    };

    const WebBrokerHeader = () => {
        return (
            <>
                <div className={'desktop:grid-col-12 tablet:grid-col-12 mobile:grid-col-12 select-list_results_col'}>
                    <h2><FormattedMessage id="gaep.web_broker.select_ga_partners"/></h2>
                </div>
            </>
        );
    };

    const CardsList = () => {
        return (
            <Cards numColumns={3}>
                {
                    data?.payload?.partners.map((item, idx) => (
                        <Cards.Row key={idx}>
                            <Cards.Col>
                                <div className={'carriers_logo'}>
                                    <img src={item.logoUrl} alt={item.organizationName}/>
                                </div>
                            </Cards.Col>
                            <Cards.Col>
                                <div className={'carriers_details'}>
                                    <h3>{item.organizationName}</h3>
                                    { item.sadpIndicator &&
                                    <div className={'carriers_details_support'}>
                                        <FontAwesomeIcon icon={faTooth}/>&nbsp;&nbsp;<FormattedMessage id='gaep.sadp'/>
                                    </div>
                                    }
                                </div>
                            </Cards.Col>
                            <Cards.Col>
                                <div className={'carriers_contact'}>
                                    <div><FormattedMessage id='gaep.phone'/> <strong>{item?.contactNumber}</strong></div>
                                    <div><GIButton id='visit-site-btn' labelId='gaep.visit.site' ariaLabel={`Visit Site ${item.organizationName}`} variant='secondary' onClickHandler={() => onHandleClickExternalUrl(item?.landingPageUrl)}/></div>
                                </div>
                            </Cards.Col>
                        </Cards.Row>
                    ))
                }
            </Cards>
        );
    };

    return (
        <>
            <div className={'select-list_results'}>
                <div className='select-list_results_header grid-row'>
                    {
                        isInsCompanyMode && <InsCompanyHeader />
                    }
                    {
                        !isInsCompanyMode && <WebBrokerHeader />
                    }
                </div>
                {
                    data &&
                    <CardsList />
                }
            </div>
        </>
    );
};

export default GAEPList;